import { TAccount } from '@helpers/Accounts/accounts.types';

import { WIDGET_REGISTRY } from './WidgetRegistry';
import {
    TAccountFeatureMap,
    TSplitTestAssignments
} from '../AccountFeatureEvaluator/AccountFeatureEvaluator';

export const WidgetRenderer = ({
    accountId,
    features,
    splitTests
}: {
    accountId: NonNullable<TAccount['account_id']>;
    features: TAccountFeatureMap;
    splitTests?: Partial<TSplitTestAssignments>;
}) => {
    const widgetsToRender = WIDGET_REGISTRY.filter((widget) =>
        widget.shouldShow(features, splitTests)
    );

    return (
        <>
            {widgetsToRender.map((widget) => {
                return (
                    <widget.component key={widget.id} accountId={accountId} />
                );
            })}
        </>
    );
};
